
import HomePage from '../pages/home.vue';
import LoginPage from '../pages/login.vue';
import InstallPage from '../pages/install.vue';
import NotFoundPage from '../pages/404.vue';


import Preferences from '../js/preferences.js';

var routes = [
  {
    path: '/',
    redirect: function (route) {
      if (!Preferences.isInstalledPWA()) return '/install/';
      return Preferences.isInitialized() ? '/home/' : '/login/';
    }
  },
  {
    path: '/login/',
    component: LoginPage
  },
  {
    path: '/home/',
    component: HomePage
  },
  {
    path: '/install/',
    component: InstallPage
  },
  {
    path: '(.*)',
    component: NotFoundPage,
  },
];

export default routes;
